'use client'

import { useEffect } from 'react'

import NextError from 'next/error'

import { sentryConfig } from '@/lib/error/sentry'

export default function GlobalError({ error }: { error: Error & { digest?: string } }) {
  useEffect(() => {
    sentryConfig.capture(error)
  }, [error])

  return (
    <html>
      <body>
        <NextError statusCode={500} />
      </body>
    </html>
  )
}
